module.exports = __webpack_public_path__ + "static/claytonbigsby-ec2f635bdbe9922e02e75b033eadf763.png";